import styled from 'styled-components'
import React from 'react'

import { formatDate, formatPrice } from 'utils/helpers'
import { dateTimeFormat } from 'utils/constants'

const Card = ({ rental, onClick }) => {
  const cardStatus = rental?.status?.toLowerCase()
  return (
    <Anchor onClick={onClick}>
      <Wrapper className={cardStatus}>
        <div className={`card-bg ${cardStatus}`}>
          <p className="item-value-large noto-sans">#{rental?.ticketNumber ? rental?.receiptNumber : ''}</p>
        </div>
        <InfoWrapper className={cardStatus}>
          <div className="item-wrapper">
            <p className="label">Customer</p>
            <p className="item-value ellipse">{rental?.customerName ? rental?.customerName: "Anonymous"}</p>
          </div>
          <div className="item-wrapper">
            <p className="label">Total Price</p>
            <p className="item-value ellipse">USD {formatPrice(rental?.totalPrice)}</p>
          </div>
          <div className="item-wrapper">
            <p className="label">Phone Number</p>
            <p className="item-value ellipse">{rental?.customerNumber || 'none'}</p>
          </div>
          <div className="item-wrapper">
            <p className="label">Purchase Date</p>
            <p className="item-value">{formatDate(rental?.purchaseDate, dateTimeFormat)}</p>
          </div>
          {rental?.dueDate && <div className="item-wrapper">
            <p className="label">Due Date</p>
            <p className="item-value ellipse">{formatDate(rental?.dueDate)}</p>
          </div>}
          <div className="item-wrapper">
            <p className="label">Originating Store</p>
            <p className="item-value ellipse">{rental?.originStoreName ?? ''}</p>
          </div>
        </InfoWrapper>
      </Wrapper>
    </Anchor>
  )
}

export default Card;

export const Anchor = styled.a`
  margin-bottom: 24px;
  margin-right: 18px;
  width: 292px;
  display: inline-block;
  opacity: 1;
  transform: translateY(0px);
  animation: fadein 300ms ease-in-out;
  @keyframes fadein {
    0% {
      opacity: 0;
      transform: translateY(5px);
    }
    100% {
      opacity: 1;
      transform: translateY(0px);
    }
  }
`;

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  border: 2px solid #6C6C6C;
  box-sizing: border-box;
  border-radius: 4px;
  background: #FFFFFF;
  &.open {
    border: 2px solid #3F76E6;
  }
  &.green {
    border-color: rgb(50,125,48);
  }
  &.closed {
    border-color: #C5C5C5;
  }
  &.extension {
    border-color: #5F5F5F;
    color: white !important;
  }
  .card-bg {
    width: 100%;
    height: 32px;
    margin: 0;
    padding-top: 0px;
    background-color: rgba(255, 165, 0, 0.5);
    &.open {
      background-color: rgba(63, 118, 230, 0.5);
    }
    &.green {
      background-color: rgba(50,125,48, 0.5);
    }
    &.closed {
      background-color: #C5C5C5;
    }
    &.extension {
      background-color: #5F5F5F;
      p { color: white !important; }
    }
    .item-value-large {
      margin-top: 0px;
      padding-top: 6px;
      padding-left: 12px;
      font-family: Overpass;
      font-style: normal;
      font-weight: 900;
      font-size: 22px;
      line-height: 24px;
      color: black;
    }
  }
  p {
    margin: 0;
  }
  .item-value-large {
    margin-top: 12px;
    font-family: Overpass;
    font-style: normal;
    font-weight: 900;
    font-size: 22px;
    line-height: 24px;
    color: #444053;
    &.noto-sans {
      font-family: 'Noto Sans', sans-serif;
      font-weight: 600;
    }
  }
  .ellipse {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .item-wrapper {
    &.full-width {
      width: 100%;
    }
    width: 100%;
    display: inline-block;
    margin-bottom: 12px;
    &:nth-of-type(2){
      width: calc(50% - 6px);
      margin-right: 6px;
    }
     &:nth-of-type(3) {
      width: calc(50% - 6px);
      margin-left: 6px;
    }
    &:nth-of-type(5){
      width: calc(50% - 6px);
      margin-right: 6px;
    }
    &:nth-of-type(6) {
      width: calc(50% - 6px);
      margin-left: 6px;
    }
    .label {
      font-style: normal;
      font-weight: 900;
      font-size: 12px;
      line-height: 15px;
      margin-bottom: 6px;
      color: #6C6C6C;
    }
    .item-value {
      font-style: normal;
      font-weight: 900;
      font-size: 14px;
      line-height: 18px;
      color: #444053;
      &.noto-sans {
        font-family: 'Noto Sans', sans-serif;
        font-weight: 500;
      }
    }
  }
`;

export const InfoWrapper = styled.div`
    margin-top: 0;
    border-top: 2px solid #6C6C6C;
    width: 100%;
    padding: 12px 12px 15px 12px;
    &.open {
      border-top: 2px solid #3F76E6;
    }
    &.green {
      border-color: rgb(50,125,48);
    }
    &.closed {
      border-top: 2px solid  #C5C5C5;
    }
    &.extension {
      border-top: 2px solid  #5F5F5F;
    }
`;
